import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../components/breadCrumb";
import CheckBox from "../components/common/CheckBox";
import ComboBoxData from "../components/common/ComboBoxData";
import ComboBoxDataMulti from "../components/common/ComboBoxDataMulti";
import { NumericBox } from "../components/common/NumericBox";
import PageContent from "../components/pageContent";
import ProductBreadCrumb from "../components/products/ProductBreadCrumb";
import TopBarWithBreadCrumb from "../components/TopBarWithBreadCrumb";
import { apiGetAllBasesByProduct } from "../services/BasesService";
import { apiGetAllColorsForSampleCard } from "../services/ColorsService";
import { apiGetAllProducts } from "../services/ProductsService";
import { apiGetSampleCardsForProduct } from "../services/SampleCardsService";
import { MultiSelect } from "react-multi-select-component";

import './ExportRecepturPage.css';
import { apiGetAllSellers, apiGetAllSellersForImportPrices } from "../services/SellersService";
import { apiImportPriceUploadFileWithPrices } from "../services/ImportPricesService";
import Spinner from "../components/common/Spinner";
import { useTranslation } from "react-i18next";

interface Props {
    contextLevel: string;

}

const ImportCenPage = (props: Props) => {

    const { t } = useTranslation(undefined, { keyPrefix: 'ImportPrices' });
    let initFormDataState: any = { sellerIds: [] };
    const [formData, setFormData] = useState(initFormDataState);
    const [sellers, setSellers] = useState([]);
    const [file, setFile] = useState<Blob>();
    const [fileName, setFileName] = useState<string>();
    const [loading, setLoading] = useState(false);
    const [completed, setCompleted] = useState(false);
    const [completedStatus, setCompletedStatus] = useState('');
    let initReport: any[] = [];
    const [importReport, setImportReport] = useState(initReport);
    const [importError, setImportError] = useState('');

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        loadSellers();
    }

    const loadSellers = async () => {

        let allSellers = await apiGetAllSellersForImportPrices();
        setSellers(allSellers.data);
    }

    const handleSellerChange = (ids) => {
        setFormData({ ...formData, sellerIds: ids });
    }

    const handleFileChange = (e: any) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);

    };

    const handleUploadFile = () => {
        if (file && fileName) {
            let sellerOptionsIds = formData.sellerIds.map(a => a.value);

            const formFileData = new FormData();
            formFileData.append('formFile', file);
            formFileData.append('fileName', fileName);

            if (sellerOptionsIds.length == sellers.length && sellerOptionsIds.length > 2) { // vsichni, ale jen pokud je jich vice nez 2, osetreni proti importu mam prava jen na sebe
                formFileData.append('allSellers', 'true');
            }
            else {
                formFileData.append('allSellers', 'false');

                sellerOptionsIds.forEach((id) => {
                    formFileData.append('sellerIds', id);
                });
            }

            try {
                setLoading(true);
                setCompleted(false);
                setCompletedStatus('');
                apiImportPriceUploadFileWithPrices(formFileData)
                    .then((responseData: any) => {

                        setLoading(false);
                        setCompleted(true);

                        if (responseData.status == 200) {

                            if (responseData.data.result == true) {
                                setImportReport(responseData.data.reports);
                                setCompletedStatus("OK");
                            }
                            else {
                                setImportError(responseData.data.error);
                                setCompletedStatus("Error");
                            }

                        }
                        else if (responseData.status == 400) {
                            setCompletedStatus(t('WrongFileOrNoData'));
                        }
                        else {
                            setCompletedStatus("Error");
                        }
                    })
                    .catch((reason: any) => {
                        alert('Error: ' + reason);
                    });
            }
            catch (ex: any) {
                console.log(ex);
                //props.onError(ex);
            }
        }
    };

    const sellersOptions = sellers.map((seller: any) => {
        return { 'label': seller.name, 'value': seller.id }
    });

    return <>
        <PageContent>
            <>
                {/*<ProductBreadCrumb selectionOfProductIsRequired={true} /> */}
                <TopBarWithBreadCrumb
                    contextLevel={props.contextLevel}
                    pageLevel={t('Label')}
                />

                {loading && <Spinner loadingText={t('PricesBeingImported')} />}

                <div className="row" style={{ padding: '20px' }}>
                    <div className="col-12">
                        <div className={`card`}>

                            <div className="card-body">

                                <MultiSelect
                                    options={sellersOptions}
                                    value={formData.sellerIds}
                                    onChange={handleSellerChange}
                                    labelledBy={t('Seller')}
                                    disabled={completedStatus == 'OK'}
                                    overrideStrings={{
                                        "allItemsAreSelected": t('allItemsAreSelected'),
                                        "clearSearch": t('clearSearch'),
                                        "clearSelected": t('clearSelected'),
                                        "noOptions": t('noOptions'),
                                        "search": t('search'),
                                        "selectAll": t('selectAll'),
                                        "selectAllFiltered": t('selectAllFiltered'),
                                        "selectSomeItems": t('selectSomeItems'),
                                        "create": t('create'),
                                    }}
                                />

                                <label>Ceník:</label>
                                <input type="file" style={{ width: '100%' }}

                                    disabled={completedStatus == 'OK'}
                                    onChange={handleFileChange}></input>


                                {!loading && completed && <div style={{ fontSize: '20px', margin: '20px', textAlign: 'center' }}>{t('ImportCompleted')} - {completedStatus}.</div>}
                                {!loading && completed && completedStatus == 'OK' &&

                                    importReport && importReport.length > 0 &&
                                    <div style={{ marginBottom: '20px' }}>
                                        <h3>Seznam chyb</h3>
                                        {importReport.filter(a => a.isError).map(
                                            (item: any) => {
                                                return <div style={{ color: 'red' }}>{item.message}</div>
                                            })}
                                    </div>
                                }



                                {!loading && completed && completedStatus == 'OK' &&
                                    importReport && importReport.length > 0 &&
                                    <>
                                        <h3>Kompletní seznam</h3>
                                        {importReport.map(
                                            (item: any) => {
                                                let color = item.isError ? 'red' : 'black';
                                                return <div style={{ color: color }}>{item.message}</div>
                                            })}
                                    </>
                                }
                                {!loading && completed && completedStatus == 'Error' &&
                                    importError && importError.length > 0 &&
                                    <span>{importError}</span>
                                }
                            </div>
                        </div>
                    </div>

                </div>

                {completedStatus != 'OK' && <>

                    <div className="row" style={{ padding: '20px', justifyContent: 'center' }}>
                        <div className="col-2" style={{ textAlign: 'center' }}>
                            <button
                                style={{ width: '100%' }}
                                onClick={() => {
                                    //
                                }}
                                type="button"
                                className="btn-sm btn-warning"
                            >
                                {t('Cancel')}
                            </button>
                        </div>
                        <div className="col-2" style={{ textAlign: 'center' }}>
                            <button
                                style={{ width: '100%' }}
                                onClick={() => {
                                    handleUploadFile();
                                }}
                                type="button"
                                className="btn-sm btn-primary"
                            >
                                {t('DoImport')}
                            </button>
                        </div>
                    </div>
                </>}
            </>
        </PageContent >
    </>
}

export default ImportCenPage;